module.exports = __webpack_public_path__ + "static/media/Informe OCT.69f04e03.jpg";